import React, { useContext } from "react";

import urlTransformerContext from "./urlTransformerContext";

export default function UrlTransformerProvider({
  children,
  transformUrl: originalTransformUrl,
  ...restProps
}) {
  const { transformUrl: parentTransformUrl } = useContext(
    urlTransformerContext,
  );
  let transformUrl = (...args) =>
    originalTransformUrl(...args, parentTransformUrl);
  return (
    <urlTransformerContext.Provider value={{ transformUrl, ...restProps }}>
      {children}
    </urlTransformerContext.Provider>
  );
}
